import { IButtonProps, mergeStyles } from "@fluentui/react";
import React from "react";
import { buttonStyle } from "../styles/StartCallButton.styles";
import { PcpPrimaryButton } from "./BaseComponents";


export interface StartCallButtonProps extends IButtonProps {
    className?: string;
    /** If set, the button is intended to rejoin an existing call. */
    rejoinCall?: boolean;
    /** True if current user is moderator (not a student). */
    isModerator?: boolean;
}

export const StartCallButton = (props: StartCallButtonProps): JSX.Element => {
    const { rejoinCall, isModerator = false } = props;
    // const locale = useLocale();

    return (
        <PcpPrimaryButton
            data-ui-id="call-composite-start-call-button"
            className={mergeStyles(buttonStyle, props.className)}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {/* NOTE: currently both button labels are identical */}
            {rejoinCall ? "Wiederaufnahme des Anrufs" : isModerator ? "Unterricht beitreten" : "Unterricht beitreten"}
        </PcpPrimaryButton>
    );
};
